// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__cqVna","loading_with_bg":"Loader_loading_with_bg__11hv5","loaderAnimation":"Loader_loaderAnimation__5wJAF","loaderText":"Loader_loaderText__haqzQ"};